import Papa from 'papaparse';
import React, { ChangeEvent } from 'react';

type Props = {
  list(items: unknown[]): void;
  disabled?: boolean;
};

const UploadAndParseField = ({ list, disabled = false }: Props) => {
  const onUploadFile = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      Papa.parse(files[0], {
        complete: ({ data }) => {
          list(data.flat());
        },
      });
    }
  };

  return (
    <div>
      <label
        htmlFor="csvUpload"
        className={`cursor-pointer border-gray-400 border-1 ml-1 align-top focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-800 focus-visible:ring-white inline-flex justify-center items-center rounded-md p-1 focus:outline-none text-gray-600 hover:text-gray-700 hover:bg-gray-300 active:bg-gray-400 hover:bg-opacity-30 dark:text-gray-200 dark:hover:text-gray-300 dark:hover:bg-gray-700 dark:active:bg-gray-800 ${
          disabled ? 'opacity-50 pointer-events-none dark:opacity-20' : ''
        }`}
      >
        Upload CSV
      </label>
      <input
        id="csvUpload"
        className="hidden"
        type="file"
        name="csv-upload"
        accept=".csv"
        onChange={onUploadFile}
        disabled={disabled}
      />
    </div>
  );
};

export default UploadAndParseField;
